import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function XAS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M19.494 10.853l-7.102 8.258-.319.389-7.568-8.563.024-.01-.029-.005 2.941-4.917.002.001L7.441 6h9.191l-.002.005 2.87 4.847zm-9.852.345l-1.627 2.755 4.013 4.584 4.023-4.621-1.592-2.727zm-2.083 2.234l1.32-2.234-3.272.005zm7.292-2.884l3.715-.006-2.332-3.906-3.662.008zm3.578.634l-3.205.006 1.285 2.201zm-4.343-.633l-2.018-3.458-2.048 3.465zm-6.3-3.895l-2.324 3.91 3.795-.007 2.31-3.91z" /><path  d="M19.494 10.103l-7.102 8.258-.319.389-7.568-8.563.024-.01-.029-.005 2.941-4.917.002.001-.002-.006h9.191l-.002.005 2.87 4.847zm-9.852.345l-1.627 2.755 4.013 4.584 4.023-4.621-1.592-2.727zm-2.083 2.234l1.32-2.234-3.272.005zm7.292-2.884l3.715-.006-2.332-3.906-3.662.008zm3.578.634l-3.205.006 1.285 2.201zM14.086 9.8l-2.018-3.458-2.048 3.465zm-6.3-3.895l-2.324 3.91 3.795-.007 2.31-3.91z" /></Svg>;
}
XAS.DefaultColor = DefaultColor;
export default XAS;